import { lazy } from "react";

const EmployeeManagement = lazy(() => import("./EmployeeManagement.js"));

const routes = [
  {
    path: "/administration/collaborators",
    exact: true,
    name: "Administración de Colaboradores de Clientes",
    component: EmployeeManagement
  }
];

export default routes;
